import useStore from "../../store";
import { useParams } from "react-router-dom";
import { useNavigateWithVars } from "../../hooks/useNavigateWithVars";
import MaterialIcon from "../MaterialIcon/MaterialIcon";
import LanguageSwitch from "../LanguageSwitch/LanguageSwitch";
import { getFirstName } from "../../util/methods";

import "./SideMenu.css";

const SideMenu = () => {
  const navigateTo = useNavigateWithVars();
  const { roundid } = useParams();
  const currentSlug = window.location.pathname;

  const getLocalized = useStore((state) => state.getLocalized);
  const gameState = useStore((state) => state.gameState);
  const game = useStore((state) => state.game);
  const currentHint = useStore((state) => state.currentHint);
  const menuOpen = useStore((state) => state.menuOpen);
  const setMenuOpen = useStore((state) => state.setMenuOpen);
  const isHost = useStore((state) => state.isHost);
  const availableLanguages = useStore((state) => state.availableLanguages);
  const character = useStore((state) => state.character);

  const roundItems = Array.from(
    { length: getLocalized("game", "Rounds") },
    (_, index) => index + 1,
  );

  const handleNavigate = (path) => {
    setMenuOpen(false);
    navigateTo(path);
  };

  return (
    <div className={`SideMenu${menuOpen ? " open" : ""}`}>
      <h2 className="title" onClick={() => handleNavigate("/")}>
        {getLocalized("game", "Name")}
      </h2>

      {character && (
        <div
          className="characterInfo"
          onClick={() => handleNavigate("/character/")}
        >
          <div className="characterInfoLabel">
            {getLocalized("texts", "DeineRolle")}
          </div>
          <div className="characterInfoRow">
            {character?.Profilbild?.data?.attributes?.url ? (
              <img
                className="roleAvatar"
                src={
                  process.env.REACT_APP_CMS_URL +
                  character.Profilbild.data.attributes.url
                }
                alt={character.Name}
              />
            ) : (
              <MaterialIcon name="account_circle" className="roleIcon" />
            )}
            <div className="characterName">
              <div>{getFirstName(character.Name)}</div>
              <div>{character.Name.split(" ").slice(1).join(" ")}</div>
            </div>
          </div>
        </div>
      )}

      {isHost && (
        <div
          className="menuItem"
          onClick={() => handleNavigate("/characters/")}
        >
          <MaterialIcon small name="group" className="icon" />
          <span
            className={`menuLabel${
              currentSlug.includes("characters") ? " active" : ""
            }`}
          >
            {gameState === -1
              ? getLocalized("texts", "Vorbereitungen")
              : getLocalized("texts", "Rollen")}
          </span>
        </div>
      )}

      <div className="menuItem" onClick={() => handleNavigate("/rules/")}>
        <MaterialIcon small name="developer_guide" className="icon" />
        <span
          className={`menuLabel${
            currentSlug.includes("rules") ? " active" : ""
          }`}
        >
          {getLocalized("texts", "Spielregeln")}
        </span>
      </div>

      <div className="menuItem" onClick={() => handleNavigate("/ablauf/")}>
        <MaterialIcon small name="family_history" className="icon" />
        <span
          className={`menuLabel${
            currentSlug.includes("ablauf") ? " active" : ""
          }`}
        >
          {getLocalized("texts", "Spielablauf")}
        </span>
      </div>

      {isHost && (
        <div className="menuItem" onClick={() => handleNavigate("/downloads/")}>
          <MaterialIcon small name="download" className="icon" />
          <span
            className={`menuLabel${
              currentSlug.includes("downloads") ? " active" : ""
            }`}
          >
            {getLocalized("texts", "Downloads")}
          </span>
        </div>
      )}

      <hr />

      <div className="menuItem" onClick={() => handleNavigate("/story/")}>
        <MaterialIcon small name="book_2" className={`icon`} />
        <span
          className={`menuLabel${
            currentSlug.includes("story") ? " active" : ""
          }`}
        >
          {getLocalized("texts", "DieGeschichte")}
        </span>
      </div>
      {character && (
        <>
          <div
            className="menuItem"
            onClick={() => handleNavigate("/character/")}
          >
            <MaterialIcon small name="account_circle" className="icon" />
            <span
              className={`menuLabel${
                currentSlug.includes("character") &&
                !currentSlug.includes("characters")
                  ? " active"
                  : ""
              }`}
            >
              {getLocalized("texts", "DeineRolle")}
            </span>
          </div>

          <div
            className="menuItem"
            onClick={() => handleNavigate("/verkleidung/")}
          >
            <MaterialIcon small name="domino_mask" className="icon" />
            <span
              className={`menuLabel${
                currentSlug.includes("verkleidung") ? " active" : ""
              }`}
            >
              {getLocalized("texts", "DeineVerkleidung")}
            </span>
          </div>
        </>
      )}

      {gameState > getLocalized("game", "Rounds") + 1 && <hr />}
      {isHost && gameState > -1 && (
        <div className="menuItem" onClick={() => handleNavigate("/intro/")}>
          <MaterialIcon small name="rocket_launch" className="icon" />
          <span
            className={`menuLabel${
              currentSlug.includes("intro") ? " active" : ""
            }${gameState === 0 ? " current" : ""}`}
          >
            {getLocalized("texts", "AudioStart")}
          </span>
        </div>
      )}

      {gameState > 0 && (
        <>
          {roundItems.map((round) => (
            <div
              key={"round_" + round}
              className={`menuItem${
                gameState === round
                  ? " current"
                  : gameState < round
                    ? " disabled"
                    : ""
              }${roundid === round ? " active" : ""}`}
              onClick={() =>
                gameState >= round ? handleNavigate("/round/" + round) : null
              }
            >
              <MaterialIcon small name={"counter_" + round} className="icon" />
              <span
                className={`menuLabel${gameState === round ? " current" : ""}${
                  currentSlug.includes("round") && currentSlug.includes(round)
                    ? " active"
                    : ""
                }`}
                // style={{
                //   borderBottom: gameState == round ? "1px solid white" : "none",
                // }}
              >
                {getLocalized("texts", "Runde") + " " + round}
              </span>
            </div>
          ))}
        </>
      )}
      {(currentHint > -1 || gameState > getLocalized("game", "Rounds")) && (
        <hr />
      )}

      {currentHint > -1 && (
        <div className={`menuItem`} onClick={() => handleNavigate("/hints/")}>
          <MaterialIcon small name="mystery" className="icon" />
          <span
            className={`menuLabel${
              currentSlug.includes("hints") ? " active" : ""
            }`}
          >
            {getLocalized("texts", "Hinweise")}
          </span>
        </div>
      )}

      {gameState > getLocalized("game", "Rounds") && (
        <div className={`menuItem`} onClick={() => handleNavigate("/reveal/")}>
          <MaterialIcon small name="gavel" className="icon" />
          <span
            className={`menuLabel${
              currentSlug.includes("reveal") ? " active" : ""
            }`}
          >
            {getLocalized("texts", "Aufloesung")}
          </span>
        </div>
      )}

      {gameState > getLocalized("game", "Rounds") + 1 && (
        <div className={`menuItem`} onClick={() => handleNavigate("/outro/")}>
          <MaterialIcon small name="logout" className="icon" />
          <span
            className={`menuLabel${
              currentSlug.includes("outro") ? " active" : ""
            }`}
          >
            {getLocalized("texts", "OutroButtonText")}
          </span>
        </div>
      )}

      {availableLanguages.length > 1 && <LanguageSwitch />}
    </div>
  );
};
export default SideMenu;
